import { SetGetCreditHisotry } from './thunk/setGetCreditHistory';

export const Thunks = {
    SetGetCreditHisotry
}